import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {
    IFloatFormItemProps,
    IFormItemElement,
    IIntFormItemProps,
    IStringFormItemProps, TextFormItem
} from "../model/FormModel";
import {JSX} from "react/jsx-runtime";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";

interface IProps extends IFormItemElement
{
    ignoreErrors?: boolean;
    formItemProps:IStringFormItemProps|IFloatFormItemProps|IIntFormItemProps;
    elementProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
}

const HiddenInputFIE = (props: IProps ) =>
{
    let {
        form,
        ignoreErrors,
        formItemProps,
        elementProps
    } = props;

    const formItem = form.requireFormItem(formItemProps, formItemProps.type ?? "string", true) as TextFormItem;

    const doIgnoreErrors = !!ignoreErrors || !formItem.errorText;

    const errorWrap = (element:JSX.Element) => {
        if(doIgnoreErrors){
            return element;
        }

        return <ErrorWrapperFE
            formItem={formItem}
        >
            {element}
        </ErrorWrapperFE>
    }

    return errorWrap(<input
        {...elementProps}
        type="hidden"
        data-form-item-id={formItem.itemID}
        name={formItem.itemID}
        value={formItem.value ?? ""}
        disabled={true}
        readOnly
    />);
}

export default HiddenInputFIE;